import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-volume-off",
  templateUrl: "./med-icon-volume-off.component.html",
})
export class MedIconVolumeOffComponent extends SvgMixinComponent {}
